module.exports = __webpack_public_path__ + "media/images/noimg_user_xl-62620e4736e28965eec903cb59cdd8bb.png";